export default __webpack_public_path__ + "static/media/section4-pic1.912b6bd0.png";